import { render, staticRenderFns } from "./RightView.vue?vue&type=template&id=b92da736&scoped=true&"
import script from "./RightView.vue?vue&type=script&lang=js&"
export * from "./RightView.vue?vue&type=script&lang=js&"
import style0 from "./RightView.vue?vue&type=style&index=0&id=b92da736&prod&scoped=true&lang=less&"
import style1 from "./RightView.vue?vue&type=style&index=1&id=b92da736&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b92da736",
  null
  
)

export default component.exports